var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlane(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 11,
    viewBox: "0 0 11 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.999 0.212552C10.9967 0.194217 10.9944 0.175861 10.9875 0.157526C10.9852 0.150648 10.9829 0.14147 10.9806 0.134592C10.9692 0.109379 10.9531 0.0864445 10.9348 0.0658099C10.9142 0.0474752 10.8912 0.031419 10.866 0.0199625C10.8591 0.0176626 10.85 0.0130843 10.8431 0.0130843C10.8247 0.00850604 10.8064 0.00390625 10.7881 0.00390625C10.7789 0.00390625 10.772 0.00390625 10.7628 0.00390625C10.7422 0.00390625 10.7193 0.00848454 10.6986 0.0153627C10.6941 0.0176626 10.6895 0.0176626 10.6849 0.019941H10.6826L0.138329 4.60083C0.0214001 4.65128 -0.0313255 4.78654 0.0191002 4.90347C0.0397348 4.95162 0.0764256 4.99059 0.122273 5.01352L3.95572 7.04259L5.98708 10.876C6.02605 10.9517 6.10401 10.9975 6.18885 10.9998H6.19803C6.28515 10.9975 6.36311 10.9425 6.3998 10.8623L10.9829 0.320303V0.318003C10.9852 0.313425 10.9852 0.308825 10.9875 0.304246C10.9944 0.283612 10.999 0.262977 10.999 0.240043C10.999 0.230886 11.0013 0.221708 10.999 0.212552ZM0.759644 4.82781L9.76319 0.914126L4.08639 6.58863L0.759644 4.82781ZM6.17277 10.2409L4.41196 6.9142L10.0865 1.2374L6.17277 10.2409Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlane);
export default __webpack_public_path__ + "static/media/plane.71ced506988bebd344efc347d27095fb.svg";
export { ForwardRef as ReactComponent };